var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 6,
    viewBox: "0 0 21 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 5.66732C1.19391 5.66732 0 4.47341 0 3.00065C0 1.52789 1.19391 0.333984 2.66667 0.333984C3.96853 0.333984 5.0525 1.26689 5.28653 2.50065H15.0468C15.2808 1.26689 16.3648 0.333984 17.6667 0.333984C19.1394 0.333984 20.3333 1.52789 20.3333 3.00065C20.3333 4.47341 19.1394 5.66732 17.6667 5.66732C16.3648 5.66732 15.2808 4.73442 15.0468 3.50065H5.28653C5.0525 4.73442 3.96853 5.66732 2.66667 5.66732Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3C12.6667 4.38071 11.5475 5.5 10.1667 5.5C8.78604 5.5 7.66675 4.38071 7.66675 3C7.66675 1.61929 8.78604 0.5 10.1667 0.5C11.5475 0.5 12.6667 1.61929 12.6667 3Z",
    fill: "#475467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.4e1145325fa9efb275ba5611e7e48fc6.svg";
export { ForwardRef as ReactComponent };